module.exports = __webpack_public_path__ + "static/img/11.1b2b01a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/11.png
// module id = kvXS
// module chunks = 0